import { StatusColors } from '@nexelem/components';
import { ProductionOrderStatus } from '@nexelem/api';

type ProductionOrderStatusKeys = keyof typeof ProductionOrderStatus;

type ProductionOrderStatusSettings = {
  color: StatusColors;
  label: ProductionOrderStatusKeys;
};

const statusMap: Record<ProductionOrderStatus, ProductionOrderStatusSettings> = {
  [ProductionOrderStatus.incomplete]: { color: 'orange', label: 'incomplete' },
  [ProductionOrderStatus.simulation]: { color: 'grey', label: 'simulation' },
  [ProductionOrderStatus.new]: { color: 'yellow', label: 'new' },
  [ProductionOrderStatus.production]: { color: 'blue', label: 'production' },
  [ProductionOrderStatus.done]: { color: 'green', label: 'done' },
  [ProductionOrderStatus.cancelled]: { color: 'brown', label: 'cancelled' },
};

export const productionOrderStatusMap = (status: ProductionOrderStatus): ProductionOrderStatusSettings =>
  statusMap[status];
